import React from 'react';
import { DateTime } from 'luxon';
import { PageFiltersRenderer, presetToValue, CalendarDatePickerPreset } from '@diana/core';
import { FilterType } from '../../stores/useFilters';
import { IExtendedPageFilterProps } from '../../hooks/useFilters';

export const TimeRangeFilter: React.FC<IExtendedPageFilterProps> = (props) => {
  const { filtersValues, setFiltersValues } = props;

  if (filtersValues[FilterType.TIME_RANGE]?.[0]?.preset) {
    const preset = filtersValues[FilterType.TIME_RANGE][0].preset as CalendarDatePickerPreset;
    const [start, end] = presetToValue({ preset }) || [];

    // Create a new filtersValues object by only modifying the TIME_RANGE
    const newFiltersValues = {
      ...filtersValues,
      [FilterType.TIME_RANGE]: [
        {
          value: DateTime.fromFormat(start, "yyyy-MM-dd'T'HH:mm").toUTC().toISO(),
          displayName: start,
          preset,
        },
        {
          value: DateTime.fromFormat(end, "yyyy-MM-dd'T'HH:mm").toUTC().toISO(),
          displayName: end,
          preset,
        },
      ],
    };

    const oldTimeRange = filtersValues[FilterType.TIME_RANGE];
    const newTimeRange = newFiltersValues[FilterType.TIME_RANGE];

    // Helper function to safely convert to DateTime or return null
    const safeDateTime = (value: string | null) => (value ? DateTime.fromISO(value) : null);

    // Convert dates to DateTime objects, handling null values
    const oldStart = safeDateTime(oldTimeRange[0]?.value as string);
    const newStart = safeDateTime(newTimeRange[0]?.value as string);

    const oldEnd = safeDateTime(oldTimeRange[1]?.value as string);
    const newEnd = safeDateTime(newTimeRange[1]?.value as string);

    // Only compare if both dates are non-null
    if (
      (oldStart && newStart && !oldStart.hasSame(newStart, 'minute')) ||
      (oldEnd && newEnd && !oldEnd.hasSame(newEnd, 'minute'))
    ) {
      setFiltersValues(newFiltersValues);
    }
  }

  return (
    <PageFiltersRenderer
      filterProps={{ ...props, filtersValues }}
      data={[{ key: props.filter.property.key, type: props.filter.property.type!, options: [] }]}
      isLoading={false}
    />
  );
};
